export default __webpack_public_path__ + "static/media/slider_4.ea5f0ce7.png";